export interface Comic {
  id: number;
  title: string;
  category: "fantasy" | "campus" | "ancient";
  tags: string[];
  rating: number;
  status: "连载中" | "已完结";
  chapters: number;
  views: string;
  cover: string;
  summary: string;
  featured?: boolean;
  rank?: number;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: "剑与王座",
    category: "fantasy",
    tags: ["异世界", "热血冒险", "骑士"],
    rating: 9.6,
    status: "连载中",
    chapters: 168,
    views: "2.4亿",
    cover: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20comic%20cover%20of%20a%20young%20knight%20holding%20a%20glowing%20greatsword%20on%20a%20mountain%20cliff%20at%20sunset%2C%20dynamic%20manhwa%20art%20style%2C%20vibrant%20warm%20colors%2C%20detailed%20armor%20and%20dramatic%20lighting%2C%20clean%20composition&width=640&height=880&seq=mh-fantasy-01&orientation=portrait",
    summary: "被流放的贵族少年在断剑中觉醒上古骑士之力，一路复仇崛起，卷入王国更迭的宏大风暴。高燃打斗与细腻群像交织，被誉为近年最热异世界史诗。",
    featured: true,
    rank: 1,
  },
  {
    id: 2,
    title: "魔法学院倒数第一",
    category: "fantasy",
    tags: ["魔法学院", "逆袭", "搞笑"],
    rating: 9.2,
    status: "连载中",
    chapters: 142,
    views: "1.8亿",
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20comic%20cover%20of%20a%20cheerful%20student%20in%20a%20magic%20academy%20uniform%20casting%20a%20golden%20spell%20with%20floating%20rune%20circles%2C%20bright%20colorful%20manhwa%20style%2C%20playful%20energetic%20mood%2C%20clean%20background&width=640&height=880&seq=mh-fantasy-02&orientation=portrait",
    summary: "成绩垫底的转学生意外触发禁忌魔法，从此在魔法学院开启又燃又笑的逆袭之路。沙雕人设与热血战斗的反差，让人一口气追完。",
    featured: true,
  },
  {
    id: 3,
    title: "龙裔归来",
    category: "fantasy",
    tags: ["龙族", "重生", "王朝"],
    rating: 9.4,
    status: "连载中",
    chapters: 121,
    views: "1.5亿",
    cover: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20comic%20cover%20of%20a%20young%20man%20with%20dragon%20eyes%20and%20glowing%20scales%2C%20towering%20dragon%20silhouette%20behind%20him%2C%20moody%20manhwa%20illustration%2C%20rich%20teal%20and%20gold%20tones%2C%20cinematic%20lighting&width=640&height=880&seq=mh-fantasy-03&orientation=portrait",
    summary: "身负龙族血脉的落魄少年在王朝倾覆之夜觉醒，带着前世的记忆重返王都。权谋、猎杀与血统之谜层层揭开。",
  },
  {
    id: 4,
    title: "星陨试炼场",
    category: "fantasy",
    tags: ["生存游戏", "异能", "热血"],
    rating: 9.0,
    status: "已完结",
    chapters: 206,
    views: "1.1亿",
    cover: "https://readdy.ai/api/search-image?query=Sci-fi%20fantasy%20comic%20cover%20of%20a%20fighter%20standing%20in%20a%20glowing%20arena%20with%20meteor%20fragments%20falling%2C%20superpower%20energy%20effects%2C%20dynamic%20manhwa%20art%2C%20cool%20blue%20and%20orange%20contrast%2C%20high%20detail&width=640&height=880&seq=mh-fantasy-04&orientation=portrait",
    summary: "当天空坠落的星辰把人类卷入残酷试炼，只有异能者才能活到最后。全程无尿点的生存博弈，结局封神。",
  },
  {
    id: 5,
    title: "图书馆的召唤师",
    category: "fantasy",
    tags: ["书灵", "奇幻日常", "治愈"],
    rating: 8.8,
    status: "连载中",
    chapters: 96,
    views: "7800万",
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20fantasy%20comic%20cover%20of%20a%20girl%20surrounded%20by%20floating%20magical%20books%20and%20sparks%2C%20cozy%20library%20background%2C%20soft%20manhwa%20art%20style%2C%20warm%20muted%20palette%2C%20gentle%20atmosphere&width=640&height=880&seq=mh-fantasy-05&orientation=portrait",
    summary: "深夜图书馆里的书页会说话，少女召唤师能与书中世界对话。在治愈日常中埋藏着关于世界真相的温柔悬念。",
  },
  {
    id: 6,
    title: "恋爱攻略代码",
    category: "campus",
    tags: ["青春恋爱", "青梅竹马", "日常"],
    rating: 9.5,
    status: "连载中",
    chapters: 188,
    views: "2.1亿",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20campus%20comic%20cover%20of%20a%20couple%20of%20high%20school%20students%20under%20cherry%20blossoms%2C%20sweet%20youthful%20mood%2C%20soft%20manhwa%20art%20style%2C%20warm%20pastel%20tones%2C%20clean%20composition&width=640&height=880&seq=mh-campus-01&orientation=portrait",
    summary: "校园排行榜第一的少女，用一套自创的“恋爱攻略代码”试图攻略青梅竹马，却越陷越深。清爽画风与细腻心动，糖分超标的青春物语。",
    featured: true,
    rank: 2,
  },
  {
    id: 7,
    title: "天台上的你",
    category: "campus",
    tags: ["暗恋", "社团", "治愈"],
    rating: 9.1,
    status: "已完结",
    chapters: 132,
    views: "9800万",
    cover: "https://readdy.ai/api/search-image?query=Soft%20campus%20comic%20cover%20of%20a%20boy%20sitting%20alone%20on%20a%20school%20rooftop%20at%20golden%20hour%20looking%20at%20the%20sky%2C%20melancholic%20yet%20warm%2C%20manhwa%20art%2C%20gentle%20sunlight%2C%20pastel%20palette&width=640&height=880&seq=mh-campus-02&orientation=portrait",
    summary: "每天放学后都坐在天台发呆的他，某天被社团的“麻烦精”学姐拉进了同一个世界。关于暗恋、告别与成长的温柔故事。",
  },
  {
    id: 8,
    title: "成绩单上的同桌",
    category: "campus",
    tags: ["欢喜冤家", "校园", "轻松"],
    rating: 8.9,
    status: "连载中",
    chapters: 110,
    views: "8600万",
    cover: "https://readdy.ai/api/search-image?query=Cute%20campus%20comic%20cover%20of%20two%20deskmates%20arguing%20over%20a%20report%20card%20in%20a%20sunlit%20classroom%2C%20playful%20manhwa%20art%2C%20bright%20cheerful%20colors%2C%20lighthearted%20mood&width=640&height=880&seq=mh-campus-03&orientation=portrait",
    summary: "成绩永远并列第一的两个人，为了“第一名”的宝座展开相爱相杀的同桌之争。嘴上不服输，心里早已沦陷。",
  },
  {
    id: 9,
    title: "运动会之后",
    category: "campus",
    tags: ["青春群像", "友情", "社团"],
    rating: 8.6,
    status: "已完结",
    chapters: 94,
    views: "6200万",
    cover: "https://readdy.ai/api/search-image?query=Group%20campus%20comic%20cover%20of%20teenage%20friends%20celebrating%20after%20a%20school%20sports%20day%2C%20energetic%20manhwa%20art%2C%20dynamic%20youthful%20colors%2C%20sunny%20outdoor%20background&width=640&height=880&seq=mh-campus-04&orientation=portrait",
    summary: "一场普通的运动会，让五个性格迥异的高中生走到了一起。汗水、呐喊与和解，是青春最真实的模样。",
  },
  {
    id: 10,
    title: "我的同桌是魔王",
    category: "campus",
    tags: ["奇幻校园", "反差", "搞笑"],
    rating: 9.3,
    status: "连载中",
    chapters: 156,
    views: "1.6亿",
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20campus%20comic%20cover%20of%20a%20girl%20with%20tiny%20devil%20horns%20wearing%20a%20school%20uniform%2C%20playful%20manhwa%20art%2C%20mixing%20dark%20and%20cute%20elements%2C%20vibrant%20colors&width=640&height=880&seq=mh-campus-05&orientation=portrait",
    summary: "转学来的新同桌自称“魔王”，可连值日生都打不过。当校园日常撞上魔界危机，反差萌与笑点全开。",
  },
  {
    id: 11,
    title: "凤栖长安",
    category: "ancient",
    tags: ["宫廷", "权谋", "爱恋"],
    rating: 9.7,
    status: "连载中",
    chapters: 174,
    views: "2.2亿",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20fantasy%20comic%20cover%20of%20a%20noblewoman%20in%20ornate%20traditional%20gown%20under%20moonlight%20in%20an%20imperial%20palace%2C%20manhwa%20art%20with%20east%20asian%20aesthetic%2C%20rich%20red%20and%20gold%20tones%2C%20detailed%20costume&width=640&height=880&seq=mh-ancient-01&orientation=portrait",
    summary: "重生回到权谋深宫的她，以步步为营的智慧周旋于天子与朝堂之间。宫斗与帝王的爱恨纠缠，格局宏大。",
    featured: true,
    rank: 3,
  },
  {
    id: 12,
    title: "仙门小师妹",
    category: "ancient",
    tags: ["仙侠", "师门", "成长"],
    rating: 9.2,
    status: "连载中",
    chapters: 138,
    views: "1.3亿",
    cover: "https://readdy.ai/api/search-image?query=Wuxia%20xianxia%20comic%20cover%20of%20a%20young%20swordswoman%20in%20flowing%20white%20robes%20on%20a%20misty%20mountain%20with%20flying%20swords%2C%20manhwa%20art%20style%2C%20ethereal%20teal%20and%20white%20palette%2C%20dynamic%20pose&width=640&height=880&seq=mh-ancient-02&orientation=portrait",
    summary: "资质平平的仙门小师妹，却阴差阳错捡到一把会说话的本命飞剑。从废柴逆袭成剑仙，搞笑与燃并存。",
  },
  {
    id: 13,
    title: "将军的月亮",
    category: "ancient",
    tags: ["古装爱恋", "将军", "虐恋"],
    rating: 8.7,
    status: "已完结",
    chapters: 102,
    views: "7400万",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20ancient%20comic%20cover%20of%20a%20general%20and%20a%20lady%20gazing%20at%20the%20moon%20on%20a%20city%20wall%20at%20night%2C%20melancholic%20manhwa%20art%2C%20deep%20blue%20and%20silver%20moonlight%2C%20poetic%20composition&width=640&height=880&seq=mh-ancient-03&orientation=portrait",
    summary: "边关将军与宫墙闺秀隔着烽火与世俗相望，一段在乱世中缱绻又克制的古装爱恋。画面唯美，后劲十足。",
  },
  {
    id: 14,
    title: "青丘九尾狐",
    category: "ancient",
    tags: ["玄幻", "人妖恋", "治愈"],
    rating: 9.0,
    status: "连载中",
    chapters: 88,
    views: "6900万",
    cover: "https://readdy.ai/api/search-image?query=Mythical%20ancient%20fantasy%20comic%20cover%20of%20a%20white%20nine-tailed%20fox%20turning%20into%20a%20beautiful%20woman%20in%20an%20enchanted%20forest%2C%20manhwa%20art%2C%20dreamy%20pastel%20and%20mystical%20glow%2C%20ethereal%20mood&width=640&height=880&seq=mh-ancient-04&orientation=portrait",
    summary: "隐居青丘的九尾狐误入人间，与书生气质的少年结下不解之缘。妖与人的温柔羁绊，在秘境与凡尘间徐徐展开。",
  },
  {
    id: 15,
    title: "长安夜市录",
    category: "ancient",
    tags: ["市井", "单元剧", "温情"],
    rating: 8.5,
    status: "已完结",
    chapters: 76,
    views: "5100万",
    cover: "https://readdy.ai/api/search-image?query=Warm%20ancient%20street%20market%20comic%20cover%20with%20lanterns%20and%20stalls%20at%20night%2C%20cozy%20manhwa%20art%2C%20rich%20warm%20colors%2C%20lively%20yet%20tender%20mood&width=640&height=880&seq=mh-ancient-05&orientation=portrait",
    summary: "一家开在长安夜市深处的无名小摊，每晚接待形形色色的客人。单元式的市井温情，治愈又下饭。",
  },
];

export function getComicsByCategory(category: string) {
  if (!category || category === "all") return comics;
  return comics.filter((c) => c.category === category);
}

export function getFeaturedComics() {
  return comics.filter((c) => c.featured);
}

export function getTopRanked() {
  return comics
    .filter((c) => c.rank)
    .sort((a, b) => (a.rank ?? 99) - (b.rank ?? 99));
}

export function getComicById(id: number) {
  return comics.find((c) => c.id === id);
}